export const CART_LINK =
  'https://movesuave.com/cart/add?id=53349330977133&quantity=1'

export const META_PIXEL_ID = '1291712646442812'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_name: 'MOVÉ SUAVE™',
      content_ids: ['53349330977133'],
      content_type: 'product',
      currency: 'ARS',
      value: 14999,
    })
  }
}
